import { render, staticRenderFns } from "./Widget1Newsfeed.vue?vue&type=template&id=f7fcb0d2&scoped=true"
import script from "./Widget1Newsfeed.vue?vue&type=script&lang=js"
export * from "./Widget1Newsfeed.vue?vue&type=script&lang=js"
import style0 from "./Widget1Newsfeed.vue?vue&type=style&index=0&id=f7fcb0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7fcb0d2",
  null
  
)

export default component.exports